import save from "save-file";
import generateCSV from "../../services/CSVController";
import { denominatorToFull } from "../../utils/rawPrice";
import { toLocalDateTime } from "../../yoello-lib/modules/utils/TimeConversion";

export interface ICustomerData {
    contact_fullname: string | null;
    contact_email: string | null;
    contact_phone:string | null;
    last_order_date:string | null;
    total_gratuity:number | null;
    total_orders:number | null;
    total_refunded:number | null;
    total_spent:number | null;
    order_ids:string[] | []
}

export function generateCustomerDataReport(consumersReport: ICustomerData[], startDate: string, endDate: string) {

    const reportData = generatePrice(consumersReport);
    const arrayOfKeys = ["contact_fullname", "contact_email", "contact_phone", "total_orders", "total_spent", "total_gratuity", "total_refunded", "last_order_date", "order_ids" ];
    const arrayOfHeaders = ["Customer Name", "Customer Email", "Customer Phone", "Total Orders", "Total Spent", "Total Tips", "Total Refunded", "Date Of Last Order", "Order History"];
  
    const csvString = generateCSV(reportData, arrayOfKeys, arrayOfHeaders);
    save(csvString, 
      `customers-data-report-from${
        toLocalDateTime(startDate, "DD/MM/YYYY HH:mm")
      }to${
        toLocalDateTime(endDate, "DD/MM/YYYY HH:mm")
      }.csv`
      );
    return;
}


function generatePrice(consumersReport: ICustomerData[]) {
    
    return consumersReport.map((consumer) => {
        const newObject: any = {};
        for (const key in consumer) {
            if(key === "order_ids" ){
                if(consumer[key].length > 0){
                    newObject[key] = '"' + consumer[key].join(',') + '"';
                }  
            }if(key === "last_order_date" && consumer[key]){
                newObject[key] = toLocalDateTime(consumer[key] as string, "DD/MM/YYYY HH:mm")
            }else{
                const value = consumer[key as keyof ICustomerData];
                if(typeof value === "number"){
                    if(key === "total_orders"){
                        newObject[key] = value;
                    }else{
                        newObject[key] = denominatorToFull(value??0);
                    }
                }else{
                    newObject[key] = value
                }
            }
        }
        return {
            ...newObject,
        };
    });
}